import { Spinner } from '@/components/common';
import styles from './LoadingScreen.module.css';

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className={styles.container} role="status" aria-live="polite">
      <Spinner size="lg" />
      <p className={styles.message}>{message}</p>
    </div>
  );
}
